module.exports = __webpack_public_path__ + "img/footer-warning.cf21cada.png";